import { render, staticRenderFns } from "./CommonDistrictSelector.vue?vue&type=template&id=08a126ca&lang=pug&"
import script from "./CommonDistrictSelector.vue?vue&type=script&lang=ts&"
export * from "./CommonDistrictSelector.vue?vue&type=script&lang=ts&"
import style0 from "./CommonDistrictSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports